import React from "react";
import "./BidType.css";
import BidTypeLogo from "../../../assets/bidtypelogo.png";

function BidType() {
  return (
    <div className="bidtype-container">
      <div className="bidtype-content">
        <div className="bidtype-text-container">
          <h1 className="bidtype-main-title">BidType.com</h1>
          <h2 className="bidtype-second-title">
            Elevating Vehicle Trade to an Exquisite Art Form
          </h2>
          <p className="bidtype-description">
            BidType.com transcends being a mere digital marketplace; it
            epitomizes an orchestrated symphony of technological acumen and
            automotive passion. Envision a domain where vehicular transactions
            transcend the mundane and transform into a virtual stage where
            global automotive enthusiasts engage in an intricate spectacle of
            admiration and acquisition. Our groundbreaking auction dynamics
            transcend a mere feature; they stand as a testament to our
            unwavering resolve to redefine conventional paradigms. The
            harmonious amalgamation of state-of-the-art listings, meticulously
            captured imagery, and intricate specifications form not just
            information, but the bedrock for informed decision-making.
            BidType.com seamlessly merges technology and automotive finesse,
            bridging geographical distances and uniting aficionados within a
            realm where the vehicular narrative is painstakingly orchestrated.
            <br />
            <br />
            • A global online vehicle marketplace seamlessly connecting
            discerning buyers and sellers.
            <br />
            • Innovative auction system empowering users to competitively bid
            and secure vehicles.
            <br />
            • Detailed and exhaustive vehicle listings featuring precise
            specifications and vivid imagery.
            <br />• An intuitive and user-friendly interface facilitating
            effortless navigation and transparent transactions.
          </p>
        </div>
        <a
          href="https://bidtype.com/bid-type/frontend/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="bidtype-logo-container">
            <img
              src={BidTypeLogo}
              alt="BidType Logo"
              className="bidtype-logo"
            />
          </div>
        </a>
      </div>
    </div>
  );
}

export default BidType;
